import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-start" }
const _hoisted_2 = { class: "bg-primary30 rounded-[11.2px] p-2.5" }
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "white",
  class: "w-6 h-6",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6 text-primary30",
  "aria-hidden": "true"
}
const _hoisted_6 = ["d"]
const _hoisted_7 = { class: "flex flex-col text-left" }
const _hoisted_8 = { class: "text-primary50 font-bold text-base leading-6 tracking-[0.08px]" }
const _hoisted_9 = { class: "text-[#52526F] text-sm leading-[18px] tracking-[0.07px]" }
const _hoisted_10 = { class: "bg-primary30 rounded-[11.2px] p-2.5 flex-shrink-0" }
const _hoisted_11 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "white",
  class: "w-6 h-6",
  "aria-hidden": "true"
}
const _hoisted_12 = ["d"]
const _hoisted_13 = { class: "flex flex-col min-w-0" }
const _hoisted_14 = { class: "text-primary50 font-bold text-base leading-6 tracking-[0.08px]" }
const _hoisted_15 = { class: "text-[#52526F] text-sm leading-[18px] tracking-[0.07px]" }
const _hoisted_16 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6 ml-auto flex-shrink-0 text-primary30",
  "aria-hidden": "true"
}
const _hoisted_17 = ["d"]

import { mdiChevronRight } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectCard',
  props: {
    icon: {},
    title: {},
    description: {},
    layout: { default: 'horizontal' }
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_ctx.layout === 'vertical')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        role: "button",
        tabindex: "0",
        class: "flex flex-col gap-2 p-4 border border-primary30 rounded-lg cursor-pointer bg-white hover:shadow-md transition-shadow h-full",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
        onKeydown: [
          _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('click')), ["enter"])),
          _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('click')), ["prevent"]), ["space"]))
        ]
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              _createElementVNode("path", { d: _ctx.icon }, null, 8, _hoisted_4)
            ]))
          ]),
          (_openBlock(), _createElementBlock("svg", _hoisted_5, [
            _createElementVNode("path", { d: _unref(mdiChevronRight) }, null, 8, _hoisted_6)
          ]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.description), 1)
        ])
      ], 32))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        role: "button",
        tabindex: "0",
        class: "flex items-center gap-3 p-4 border border-primary30 rounded-lg cursor-pointer bg-white hover:shadow-md transition-shadow text-left",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click'))),
        onKeydown: [
          _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('click')), ["enter"])),
          _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('click')), ["prevent"]), ["space"]))
        ]
      }, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createElementBlock("svg", _hoisted_11, [
            _createElementVNode("path", { d: _ctx.icon }, null, 8, _hoisted_12)
          ]))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.title), 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.description), 1)
        ]),
        (_openBlock(), _createElementBlock("svg", _hoisted_16, [
          _createElementVNode("path", { d: _unref(mdiChevronRight) }, null, 8, _hoisted_17)
        ]))
      ], 32))
}
}

})